
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';
import Rechtliches from '../pages/rechtliches/page';
import TestEmailPage from '../pages/test-email/page';
import BestellungPage from '../pages/bestellung/page';
import BestelluebersichtPage from '../pages/bestelluebersicht/page';
import BestellungenKundenPage from '../pages/bestellungen-kunden/page';
import BestellbestaetigungPage from '../pages/bestellbestaetigung/page';

// Lazy loading für bessere Performance
const Home = lazy(() => import('../pages/home/page'));
const Shop = lazy(() => import('../pages/shop/page'));
const Checkout = lazy(() => import('../pages/checkout/page'));
const Admin = lazy(() => import('../pages/admin/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Shop />, // Startseite ist jetzt direkt der Shop
  },
  {
    path: '/home',
    element: <Home />,
  },
  {
    path: '/shop',
    element: <Shop />,
  },
  {
    path: '/about',
    element: (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-8 bg-white rounded-2xl shadow-xl">
          <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-information-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Über uns</h2>
          <p className="text-gray-600 mb-6">
            Alle Informationen über uns finden Sie auf unserer Hauptseite.
          </p>
          <a 
            href="https://snaeckomat.ch" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-orange-500 to-cyan-500 text-white px-6 py-3 rounded-full font-semibold hover:from-orange-600 hover:to-cyan-600 transition-all cursor-pointer"
          >
            Zur Hauptseite
          </a>
        </div>
      </div>
    ),
  },
  {
    path: '/contact',
    element: (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="max-w-md mx-auto text-center p-8 bg-white rounded-2xl shadow-xl">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <i className="ri-phone-line text-2xl text-green-600"></i>
          </div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Kontakt</h2>
          <p className="text-gray-600 mb-6">
            Alle Kontaktinformationen finden Sie auf unserer Hauptseite.
          </p>
          <a 
            href="https://snaeckomat.ch" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-orange-500 to-cyan-500 text-white px-6 py-3 rounded-full font-semibold hover:from-orange-600 hover:to-cyan-600 transition-all cursor-pointer"
          >
            Zur Hauptseite
          </a>
        </div>
      </div>
    ),
  },
  {
    path: '/checkout',
    element: <Checkout />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '/rechtliches',
    element: <Rechtliches />
  },
  {
    path: '/test-email',
    element: <TestEmailPage />,
  },
  {
    path: '/bestellung',
    element: <BestellungPage />
  },
  {
    path: '/bestelluebersicht',
    element: <BestelluebersichtPage />,
  },
  {
    path: '/bestellungen-kunden',
    element: <BestellungenKundenPage />,
  },
  {
    path: '/bestellbestaetigung',
    element: <BestellbestaetigungPage />
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
